/* ============================================================
   Athena Olive Oil — theme.js
   Carousel (steady transition + animation lock, viewport autoplay,
   swipe), theme toggle, mobile menu, AJAX cart drawer.
   Vanilla JS only. Ported from the brand prototype.
   ============================================================ */
(function(){
  "use strict";

  /* ---------- Scroll reveal ---------- */
  function setupReveal(){
    var items = document.querySelectorAll('.reveal');
    if(!('IntersectionObserver' in window)){
      items.forEach(function(el){ el.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {threshold:.12, rootMargin:"0px 0px -40px 0px"});
    items.forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.top<window.innerHeight && r.bottom>0){ el.classList.add('in'); } else io.observe(el);
    });
  }

  /* ---------- Carousel (lifestyle + product gallery) ---------- */
  function buildCarousels(){
    document.querySelectorAll('.carousel-wrap').forEach(function(wrap){
      var track   = wrap.querySelector('.carousel-track');
      if(!track) return;
      var slides  = track.querySelectorAll('.c-slide');
      if(slides.length <= 0) return;
      var dotsWrap= wrap.querySelector('.ecar-dots');
      var prevBtn = wrap.querySelector('.ecar-prev');
      var nextBtn = wrap.querySelector('.ecar-next');
      var autoplay = wrap.getAttribute('data-autoplay') !== 'false';
      var idx = 0, animating = false, timer = null;
      var dots = [];

      // build dots
      if(dotsWrap){
        for(var i=0;i<slides.length;i++){
          var dot = document.createElement('button');
          dot.type='button';
          dot.className = 'ecar-dot' + (i===0?' active':'');
          dot.setAttribute('aria-label','Slide '+(i+1));
          (function(j){ dot.addEventListener('click', function(){ resetTimer(); go(j); }); })(i);
          dotsWrap.appendChild(dot);
        }
        dots = dotsWrap.querySelectorAll('.ecar-dot');
      }

      function render(){
        track.style.transform = 'translateX(-'+idx+'00%)';
        dots.forEach(function(d,j){ d.classList.toggle('active', j===idx); });
      }
      function go(n, silent){
        if(animating) return;
        var t=((n % slides.length)+slides.length)%slides.length;
        if(t===idx) return;
        animating=true; idx=t; render();
        if(!silent && typeof wrap.onSlide === 'function') wrap.onSlide(idx);
      }
      track.addEventListener('transitionend', function(e){ if(e.propertyName==='transform') animating=false; });
      if(slides.length<=1){ if(prevBtn) prevBtn.style.display='none'; if(nextBtn) nextBtn.style.display='none'; if(dotsWrap) dotsWrap.style.display='none'; }
      if(prevBtn) prevBtn.addEventListener('click', function(){ resetTimer(); go(idx-1); });
      if(nextBtn) nextBtn.addEventListener('click', function(){ resetTimer(); go(idx+1); });

      function tick(){
        if(document.body.classList.contains('cart-open')) return;
        animating=true; idx=(idx+1)%slides.length; render();
      }
      function start(){ if(autoplay && slides.length>1 && !timer) timer = setInterval(tick, 5500); }
      function stop(){ if(timer){ clearInterval(timer); timer=null; } }
      function resetTimer(){ if(timer){ clearInterval(timer); timer=null; start(); } }

      // swipe
      var startX=null;
      track.addEventListener('touchstart', function(e){ startX=e.touches[0].clientX; }, {passive:true});
      track.addEventListener('touchend', function(e){
        if(startX===null) return;
        var dx=e.changedTouches[0].clientX-startX;
        if(Math.abs(dx)>40){ resetTimer(); go(idx + (dx<0?1:-1)); }
        startX=null;
      });

      // autoplay only while in viewport
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(en){ if(en.isIntersecting) start(); else stop(); });
        }, {threshold:0.3});
        io.observe(wrap);
      } else { start(); }

      // expose sync hook (used by product gallery <-> variant pills)
      wrap.carouselGo = function(n){ resetTimer(); go(n, true); };
      render();
    });
  }

  /* ---------- Mobile menu ---------- */
  function setupMenu(){
    var toggle = document.querySelector('.menu-toggle');
    var list = document.getElementById('navlist');
    if(toggle && list){
      toggle.addEventListener('click', function(){ list.classList.toggle('open'); });
      list.querySelectorAll('a').forEach(function(a){
        a.addEventListener('click', function(){ list.classList.remove('open'); });
      });
    }
  }

  /* ---------- Theme toggle (localStorage 'athenaTheme') ---------- */
  function setupTheme(){
    var KEY='athenaTheme';
    var btn=document.getElementById('themeToggle');
    function apply(t){
      var dark=(t==='dark');
      document.body.classList.toggle('theme-dark', dark);
      if(btn){ btn.innerHTML = dark ? '☀' : '☽'; }
    }
    var saved=null; try{ saved=localStorage.getItem(KEY); }catch(e){}
    apply(saved||'light');
    if(btn){ btn.addEventListener('click', function(){
      var dark=!document.body.classList.contains('theme-dark');
      apply(dark?'dark':'light');
      try{ localStorage.setItem(KEY, dark?'dark':'light'); }catch(e){}
    }); }
  }

  /* ---------- AJAX cart ---------- */
  var money = function(cents){
    var sym = (window.Shopify && Shopify.currency && Shopify.currency.active === 'INR') ? '₹' : '₹';
    return sym + (cents/100).toLocaleString('en-IN', {minimumFractionDigits:0, maximumFractionDigits:2});
  };

  function openDrawer(){
    document.body.classList.add('cart-open');
    var d=document.querySelector('.cart-drawer'), b=document.querySelector('.cart-backdrop');
    if(d) d.classList.add('open'); if(b) b.classList.add('open');
  }
  function closeDrawer(){
    document.body.classList.remove('cart-open');
    var d=document.querySelector('.cart-drawer'), b=document.querySelector('.cart-backdrop');
    if(d) d.classList.remove('open'); if(b) b.classList.remove('open');
  }

  function updateCount(count){
    document.querySelectorAll('.cart-count').forEach(function(el){
      el.textContent = count;
      if(count>0){ el.removeAttribute('hidden'); } else { el.setAttribute('hidden',''); }
    });
  }

  function renderCart(cart){
    updateCount(cart.item_count);
    var itemsEl = document.querySelector('.cart-items');
    var totalEl = document.querySelector('.cart-total-amount');
    var footEl  = document.querySelector('.cart-foot');
    if(!itemsEl) return;
    if(cart.item_count === 0){
      itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      if(footEl) footEl.style.display='none';
      return;
    }
    if(footEl) footEl.style.display='';
    itemsEl.innerHTML = cart.items.map(function(it){
      var img = it.image ? it.image.replace(/(\.[^.]*)$/, '_120x$1') : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '<div class="cart-line" data-key="'+it.key+'">' +
        (img ? '<img src="'+img+'" alt="'+it.product_title+'">' : '<div></div>') +
        '<div><div class="cl-title">'+it.product_title+'</div>' +
        (variant ? '<div class="cl-variant">'+variant+'</div>' : '') +
        '<div class="cl-price">'+it.quantity+' × '+money(it.final_price)+'</div>' +
        '<button class="cl-remove" type="button" data-key="'+it.key+'">Remove</button></div>' +
        '<div class="cl-line-total">'+money(it.final_line_price)+'</div>' +
      '</div>';
    }).join('');
    if(totalEl) totalEl.textContent = money(cart.total_price);
    itemsEl.querySelectorAll('.cl-remove').forEach(function(b){
      b.addEventListener('click', function(){ changeItem(b.getAttribute('data-key'), 0); });
    });
  }

  function refreshCart(open){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); if(open) openDrawer(); })
      .catch(function(){});
  }

  function changeItem(key, qty){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); });
  }

  function addToCart(form){
    var btn = form.querySelector('[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if(btn){ btn.disabled=true; btn.textContent='Adding…'; }
    var data = new FormData(form);
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Accept':'application/json'},
      body: data
    }).then(function(r){
      if(!r.ok) return r.json().then(function(e){ throw e; });
      return r.json();
    }).then(function(){
      refreshCart(true);
      if(btn){ btn.disabled=false; btn.textContent=orig; }
    }).catch(function(err){
      if(btn){ btn.disabled=false; btn.textContent=orig; }
      alert((err && err.description) ? err.description : 'Sorry, could not add to cart.');
    });
  }

  function setupCart(){
    // add-to-cart forms
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function(form){
      form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(form); });
    });
    // open drawer triggers
    document.querySelectorAll('[data-cart-open]').forEach(function(el){
      el.addEventListener('click', function(e){ e.preventDefault(); refreshCart(true); });
    });
    // close triggers
    document.querySelectorAll('[data-cart-close]').forEach(function(el){
      el.addEventListener('click', function(e){ e.preventDefault(); closeDrawer(); });
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });
    // initial count
    refreshCart(false);
  }

  /* ---------- Product page: variant pills ---------- */
  function setupProductForms(){
    document.querySelectorAll('[data-product-form]').forEach(function(root){
      var pills = root.querySelectorAll('input[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var btn = root.querySelector('[type="submit"]');
      var gallery = root.querySelector('.carousel-wrap') ||
                    (root.closest('.product-page') ? root.closest('.product-page').querySelector('.carousel-wrap') : null);
      function update(input){
        if(priceEl) priceEl.textContent = input.getAttribute('data-price');
        if(compareEl){
          var c = input.getAttribute('data-compare');
          compareEl.textContent = c || '';
          compareEl.style.display = c ? '' : 'none';
        }
        var avail = input.getAttribute('data-available') === 'true';
        if(btn){ btn.disabled = !avail; btn.textContent = avail ? (btn.getAttribute('data-add-label')||'Add to Cart') : 'Sold Out'; }
        var mi = input.getAttribute('data-media-index');
        if(gallery && gallery.carouselGo && mi !== null && mi !== ''){ gallery.carouselGo(parseInt(mi,10)); }
      }
      pills.forEach(function(input){
        input.addEventListener('change', function(){ if(input.checked) update(input); });
      });
      // Reverse sync: navigating the gallery carousel selects the matching variant + price
      if(gallery){
        gallery.onSlide = function(slideIdx){
          var match = null;
          pills.forEach(function(inp){
            if(parseInt(inp.getAttribute('data-media-index'), 10) === slideIdx) match = inp;
          });
          if(match && !match.checked){ match.checked = true; update(match); }
        };
      }
      var checked = root.querySelector('input[name="id"]:checked');
      if(checked) update(checked);
    });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function(){
    setupTheme();
    setupMenu();
    buildCarousels();
    setupProductForms();
    setupReveal();
    setupCart();
  });
})();
